import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
} from '@angular/core'
import { ProgressIndicatorStatusItem } from './radial-stepper'

@Component({
    selector: 'app-radial-stepper',
    templateUrl: './radial-stepper.component.html',
    styleUrls: ['./radial-stepper.component.scss'],
})
export class RadialStepperComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() statusItem!: ProgressIndicatorStatusItem
    @Input() currentStatus = 0
    @Input() completeDescription = ''
    @Input() hideNextStep = false

    @ViewChild('circularProgress') progressIndicator!: ElementRef<HTMLElement>

    constructor() {}

    ngOnInit() {}

    ngAfterViewInit(): void {
        if (!this.isRejected()) {
            this.fillProgressBar()
        }
    }

    ngOnChanges(changes: SimpleChanges): void {}

    isComplete() {
        return this.getCompletedSteps() === this.statusItem.approvalStatuses.length
    }

    isRejected() {
        return this.statusItem.rejectStatuses.some(status => status.id === this.currentStatus)
    }

    getCompletedPercent() {
        return (this.getCompletedSteps() / this.statusItem.approvalStatuses.length) * 100
    }

    getProgressBarColor() {
        return this.isRejected() ? '--color-danger' : '--color-primary'
    }

    fillProgressBar() {
        this.progressIndicator.nativeElement.style.background = `conic-gradient( var(${this.getProgressBarColor()}) ${
            this.getCompletedPercent() * 3.6
        }deg, var(--border-color) 0deg)`
    }

    getCompletedSteps() {
        return this.statusItem.approvalStatuses.filter(status => status.id <= this.currentStatus)
            .length
    }

    getProgressText() {
        return `${this.getCompletedSteps() || 0} de ${this.statusItem.approvalStatuses.length}`
    }

    getCurrentStatusName() {
        if (this.isRejected()) {
            const currentStatus = this.statusItem.rejectStatuses.find(
                status => status.id === this.currentStatus,
            )
            return currentStatus ? currentStatus.name : this.statusItem.rejectStatuses[0].name
        } else {
            const currentStatus = this.statusItem.approvalStatuses.find(
                status => status.id === this.currentStatus,
            )
            return currentStatus ? currentStatus.name : this.statusItem.approvalStatuses[0].name
        }
    }

    getNextStatusName() {
        if (!this.isComplete()) {
            const currentStatusIndex = this.statusItem.approvalStatuses
                .map(status => status.id)
                .indexOf(this.currentStatus)
            return this.statusItem.approvalStatuses[currentStatusIndex + 1].name
        }
        return ''
    }

    getStatusDescription() {
        if (this.isRejected()) {
            const currentStatus = this.statusItem.rejectStatuses.find(
                status => status.id === this.currentStatus,
            )
            return currentStatus ? currentStatus.description : ''
        } else {
            const currentStatus = this.statusItem.approvalStatuses.find(
                status => status.id === this.currentStatus,
            )
            return currentStatus ? currentStatus.description : ''
        }
    }
}
